export enum UnitSystem {
    METRIC = <any>'metric',
    IMPERIAL = <any>'imperial'
}


// WEBPACK FOOTER //
// /Users/cwseger/go/src/github.com/cwseger/travel-time-ui/src/app/enums/unit-system.enum.ts